import axios from 'axios'
const API_URL = 'https://arrandi.fr/api/auth/'


class AuthService {
  login (connexion) {
    console.log("login" + connexion.email +" "+ connexion.password)
    return axios
      .post(API_URL + 'signin', {
        email: connexion.email,
        password: connexion.password,
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data))
        }
        return response.data
      })
  }

  logout () {
    localStorage.removeItem('user')
  }

  register (user) {
    return axios.post(API_URL + 'signup', {
      email: user.email,
      password: user.password,
      emailValidation: user.emailValidation,
      validationCount: user.validationCount,
      abonnement: user.abonnement,
      dateDebutAbonnement: user.dateDebutAbonnement,
      dateFinAbonnement: user.dateFinAbonnement,
      role: user.role,
      status: "pending",
    })
  }

  verifyUser (confirmationCodeReq) {
    return axios
      .post(API_URL + 'verifyUser', {
        confirmationCode: confirmationCodeReq,
      })
  }

  changePassword (req) {
    return axios
      .post(API_URL + 'changePassword', req)
  }

  forgotpassword(email){
    return axios
      .post(API_URL + 'forgotpassword', {
        email: email,
      })
  }

  verifyToken(tokenFromLink){
    return axios
      .post(API_URL + 'verifyToken', {
        token: tokenFromLink,
      })
      // .catch((error) => {
      //   console.log("err ", JSON.parse(error.request.response).message)
      // })
  }
}
export default new AuthService()
